import React, { useState } from 'react'
import Link from '../../../components/link/Link'
import { downloadPDF } from '../../contracts/contracts_body/docs/documentMapper'
import langEnum from '../../../enums/langEnum'
import { CircularProgress } from '@material-ui/core'
import { ModelDoc } from '../../contracts/contracts_body/docs/docs_model'
import { useIntl } from 'react-intl'
import classNames from 'classnames'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../styles'


const useStyle = makeStyles((theme) => ({
    ...styles(theme),
    disabledLink: {
        pointerEvents: 'none'
    },
    cardStyle: {
        marginBottom: 12
    }
}))

interface AcceptingProps {
    key: number,
    doc: ModelDoc,
}

type LinkCardProps = AcceptingProps

const LinkCard: React.FC<LinkCardProps> = (
    {
        key,
        doc
    }
) => {
    const intl = useIntl()
    const classes = useStyle()
    const [loadingDdl, setLoadingDdl] = useState<boolean>(false)
    const cardLinkDocumentsClass = classNames(
        loadingDdl && classes.disabledLink,
        loadingDdl && 'col-xs-10'
    )

    const circularProgressClass = classNames(
        'col-xs-2'
    )

    const cardRecentDocumentsClass = classNames(
        classes.cardStyle,
        classes.text6,
        loadingDdl && 'row'
    )

    return (
        <div key={key} className={cardRecentDocumentsClass}>
            <Link
                color="colorBlue"
                textStyle="text6"
                onClick={() => downloadPDF(doc, intl.locale, setLoadingDdl)}
                hasChevron={false}
                key={doc.renommage_fr}
                className={cardLinkDocumentsClass}
            >
                {
                    (intl.locale === langEnum.fr) ?
                        `${doc.renommage_fr} ${doc.dwstoredatetime.toLocaleString(intl.locale, { month: 'long' })} ${doc.dwstoredatetime.getFullYear()}`
                        :
                        `${doc.renommage_en} ${doc.dwstoredatetime.toLocaleString(intl.locale, { month: 'long' })} ${doc.dwstoredatetime.getFullYear()}`
                }
            </Link>
            {
                loadingDdl && <CircularProgress size={24} className={circularProgressClass} />
            }
        </div>
    )
}

export default LinkCard